class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(), { passive: true });
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this), { passive: true })
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick, { passive: true });
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, cartType = 'drawer') {
    const drawer = document.getElementById('cart_drawer') || document.querySelector('pfd-cart-page');
    if (typeof drawer?.renderContents === 'function') {
      drawer.renderContents(parsedState, cartType, this.activeElement);
      return;
    }
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.header) this.header.reveal();
    // this.open();

    if (cartType == 'drawer') this.cartDrawerOpen()

  }

  cartDrawerOpen() {
    const cart_drawer = document.getElementById('cart_drawer')
    cart_drawer?.openCart('')
  }

  getSectionsToRender() {
    const drawer = document.getElementById('cart_drawer') || document.querySelector('pfd-cart-page');
    if (typeof drawer?.getSectionsToRender === 'function') return drawer.getSectionsToRender();
    return [
      // {
      //   id: 'cart-notification-product',
      //   selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      // },
      // {
      //   id: 'cart-notification-button'
      // },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'main-cart-items',
        selector: '#inject_cart_items',
      },
      // {
      //   id: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '#main-cart-footer',
      // }
    ];

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
